"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormsController", {
    enumerable: true,
    get: function() {
        return FormsController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _formsservice = require("~/services/forms.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let FormsController = class FormsController {
    async formViewGet(context, formViewId) {
        const formViewData = await this.formsService.formViewGet(context, {
            formViewId
        });
        return formViewData;
    }
    async formViewCreate(context, tableId, body, req) {
        const view = await this.formsService.formViewCreate(context, {
            body,
            tableId,
            user: req.user,
            req
        });
        return view;
    }
    async formViewUpdate(context, formViewId, body, req) {
        return await this.formsService.formViewUpdate(context, {
            formViewId,
            form: body,
            req
        });
    }
    constructor(formsService){
        this.formsService = formsService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/forms/:formViewId',
        '/api/v2/meta/forms/:formViewId'
    ]),
    (0, _extractidsmiddleware.Acl)('formViewGet'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('formViewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], FormsController.prototype, "formViewGet", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/tables/:tableId/forms',
        '/api/v2/meta/tables/:tableId/forms'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('formViewCreate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.ViewCreateReqType === "undefined" ? Object : _nocodbsdk.ViewCreateReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], FormsController.prototype, "formViewCreate", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/forms/:formViewId',
        '/api/v2/meta/forms/:formViewId'
    ]),
    (0, _extractidsmiddleware.Acl)('formViewUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('formViewId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        void 0,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], FormsController.prototype, "formViewUpdate", null);
FormsController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _formsservice.FormsService === "undefined" ? Object : _formsservice.FormsService
    ])
], FormsController);
